import _ from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  isOpen: false,
  selectedPolicy: {
    policyNumber: '',
    solicitorReference: '',
    clientName: '',
  },
  questions: [],
  fetching: false,
  fetchError: '',
  formData: {},
  attachments: [],
  validationError: '',
  submitting: false,
  submitted: false,
  submitError: '',
  successMessage: '',
}

const externalPolicyUpdateActions = {
  openExternalPolicyUpdateModal: (state, { payload }) => {
    state.isOpen = true
    state.selectedPolicy = {
      policyNumber: payload.policyNumber,
      solicitorReference: payload.solicitorReference,
      clientName: payload.clientName,
    }
  },
  closeExternalPolicyUpdateModal: (state) => {
    return defaultState
  },
  fetchExternalPolicyQuestions: (state) => {
    state.fetching = true
    state.fetchError = ''
  },
  fetchExternalPolicyQuestionsSuccess: (state, { payload }) => {
    state.fetching = false
    if (!payload) return
    state.formData = _.mapValues(_.keyBy(payload, 'id'), (i, key) =>
      state.formData[key] ? state.formData[key] : ''
    )
    state.questions = payload
    state.attachments = []
  },
  fetchExternalPolicyQuestionsFailed: (state, action) => {
    state.fetching = false
    try {
      state.fetchError = action.payload.response.body.message
    } catch (error) {
      state.fetchError = 'Failed to fetch external policy questions'
    }
  },
  changeExternalPolicyFormData: (state, { payload }) => {
    const { key, value } = payload
    state.formData[key] = value
    state.validationError = ''
  },
  resetChildQuestions: (state, { payload }) => {
    const { resetIds } = payload
    resetIds.forEach((id) => {
      state.formData[id] = ''
    })
  },
  addExternalPolicyAttachment: (state, { payload }) => {
    state.attachments.push(payload)
  },
  removeExternalPolicyAttachment: (state, { payload }) => {
    state.attachments.splice(payload, 1)
  },
  setExternalPolicyValidationError: (state, { payload }) => {
    state.validationError = payload
  },
  submitExternalPolicyUpdate: (state) => {
    state.submitting = true
    state.submitError = ''
  },
  submitExternalPolicyUpdateSuccess: (state, { payload }) => {
    state.submitting = false
    state.submitted = true
    state.successMessage = payload
  },
  submitExternalPolicyUpdateFailed: (state, { payload }) => {
    state.submitting = false
    try {
      state.submitError = typeof payload === 'string' ? payload : payload.response.body.message
    } catch (error) {
      state.submitError = 'Failed to submit update. Please try again.'
    }
  },
  clearExternalPolicyErrors: (state) => {
    state.fetchError = ''
    state.submitError = ''
    state.validationError = ''
  },
}

const externalPolicyUpdate = createSlice({
  name: 'externalPolicyUpdate',
  initialState: defaultState,
  reducers: externalPolicyUpdateActions,
})

export const {
  openExternalPolicyUpdateModal,
  closeExternalPolicyUpdateModal,
  fetchExternalPolicyQuestions,
  fetchExternalPolicyQuestionsSuccess,
  fetchExternalPolicyQuestionsFailed,
  changeExternalPolicyFormData,
  resetChildQuestions,
  addExternalPolicyAttachment,
  removeExternalPolicyAttachment,
  setExternalPolicyValidationError,
  submitExternalPolicyUpdate,
  submitExternalPolicyUpdateSuccess,
  submitExternalPolicyUpdateFailed,
  clearExternalPolicyErrors,
} = externalPolicyUpdate.actions

export default externalPolicyUpdate.reducer
